

import { AiFillFacebook } from "react-icons/ai";
import { RiTwitterXFill } from "react-icons/ri";
import { LuInstagram } from "react-icons/lu";
import { IoLogoYoutube } from "react-icons/io5";
import { FaRss } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa6";
import Link from "next/link";
import { useLocale } from "next-intl";
import { IoLogoWhatsapp } from "react-icons/io5";
import { FaFacebookF } from "react-icons/fa";


export default function SocialMedia() {

  const locale = useLocale()


  return (
    <div className="flex justify-center mt-4 gap-5 text-primary">
    <FaFacebookF size={28} className=" hover:text-bl cursor-pointer"/>
    <Link href="https://x.com/PadlevOfficial" target="_blank" title="X Account">
     <RiTwitterXFill size={32} className=" hover:text-black cursor-pointer"/>
    </Link>
   

    <IoLogoWhatsapp size={32}/>
    <FaTiktok size={30} className=" hover:text-black cursor-pointer"/>

    <Link href={`/${locale}/rss`} target="_blank" rel="noopener noreferrer" title="RSS Feed"> 
    <FaRss size={32} className=" hover:text-primary cursor-pointer"/>
    </Link>
   

  </div>
  );
}